export const getAppIcon = (icons: string[] = [], size: number) =>
  icons.find((icon) => {
    const currentSize = +(icon.split('/').pop()?.match(/\d+/)?.[0] || 0)
    return currentSize === size
  }) || icons[0]
